import OrderCompleteModal from './OrderCompleteModal';

export default OrderCompleteModal;


// WEBPACK FOOTER //
// ./src/components/OrderCompleteModal/index.jsx